import type { CotizacionPdfPrecargaResult } from '../services/cotizacionVentaService';

export const PRECARGA_COTIZACION_CONFIANZA_MINIMA = 0.5;

export const MSG_CAMPO_NO_DETECTADO = 'No detectado; complete manualmente.';

export function precargaCotizacionUtilizoIa(precarga: CotizacionPdfPrecargaResult | null): boolean {
  if (!precarga?.campos?.length) return false;
  return precarga.campos.some((c) => c.fuente === 'openai');
}

export function labelClientePrecarga(precarga: CotizacionPdfPrecargaResult): string {
  const nombre = precarga.cliente.nombre?.trim()
    || precarga.formulario?.nombreClientePdf?.trim()
    || 'Sin nombre';
  const cuit = precarga.cliente.cuit?.trim();
  return cuit ? `${nombre} (${cuit})` : nombre;
}

export function debeSugerirCrearCliente(precarga: CotizacionPdfPrecargaResult | null): boolean {
  if (!precarga) return false;
  if (precarga.cliente.encontrado) return false;
  const nombre = precarga.cliente.nombre?.trim() || precarga.formulario?.nombreClientePdf?.trim();
  return Boolean(nombre);
}

export function tieneDatosUtilesPrecarga(precarga: CotizacionPdfPrecargaResult | null): boolean {
  if (!precarga) return false;
  if ((precarga.items?.length ?? 0) > 0) return true;
  if (precarga.cliente.nombre || precarga.formulario?.ordenDeCompra || precarga.formulario?.fechaEmision) {
    return true;
  }
  return false;
}

export function valorCampoPrecarga(
  precarga: CotizacionPdfPrecargaResult,
  nombre: string,
): { valor: string | null; confianza: number } {
  const campo = precarga.campos?.find((c) => c.nombre === nombre);
  if (campo?.valor != null && String(campo.valor).trim() !== '') {
    return { valor: String(campo.valor).trim(), confianza: campo.confianza };
  }
  return { valor: null, confianza: 0 };
}
